// removed by extract-text-webpack-plugin
module.exports = {"imagesSlider":"src-components-modules-Media-MediaImageSlider-style----general-module---imagesSlider---1lAdk alignItems-center display-flex justifyContent-center overflow-hidden position-relative"};


//////////////////
// WEBPACK FOOTER
// ./src/components/modules/Media/MediaImageSlider/style/general.module.css
// module id = 739
// module chunks = 227233210825294 244429959259914